import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmpresasService {

  server = 'http://localhost:4040/';
  apiEmpresasUrl = '/api/empresas';

  constructor(private http: HttpClient) {}

  getEmpresasList(): Observable<any> {
    return this.http.get(this.apiEmpresasUrl + '/empresas_list');
  }

}
